import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_PATH } from '../../consts/app.const';
import { FormOptionalFields, ICreatedEntityDto, ICreateFormDto, ICreateFormResultDto, IFormBettings, IFormDto, IFormsDto, IUpdateFormDto } from '@oogaday/shared';
import { IFormModel } from './model/form.model';
import { UtilsService } from '../../services/utils.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FormApiService {
  private readonly httpClient = inject(HttpClient);


  createForm(tournamentId: string, data: ICreateFormDto): Promise<ICreatedEntityDto> {
    return firstValueFrom(this.httpClient.post<ICreatedEntityDto>(`${API_PATH}tournaments/${tournamentId}/forms`, data))
      ;
  }

  async deleteForm(tournamentId: string, formId: string): Promise<void> {
    await firstValueFrom(this.httpClient.delete<void>(`${API_PATH}tournaments/${tournamentId}/forms/${formId}`))
    ;
  }

  async updateForm(tournamentId: string, formId: string, data: IUpdateFormDto): Promise<void> {
    await firstValueFrom(this.httpClient.put<ICreatedEntityDto>(`${API_PATH}tournaments/${tournamentId}/forms/${formId}`, data))
    ;
  }

  getForms(tournamentId: string, fields: FormOptionalFields[] = []): Promise<IFormModel[]> {
    return firstValueFrom(this.httpClient.get<IFormsDto>(`${API_PATH}tournaments/${tournamentId}/forms`, {
      params: {
        fields,
      },
    }))

      .then(({ forms }) => forms.map((form) => ({
        ...UtilsService.dtoToModel(form),
        startsAt: UtilsService.unixToDate(form.startsAt),
      })));
  }

  getFormById(tournamentId: string, formId: string, fields: FormOptionalFields[] = []): Promise<IFormModel> {
    return firstValueFrom(this.httpClient.get<IFormDto>(`${API_PATH}tournaments/${tournamentId}/forms/${formId}`, {
      params: {
        fields,
      },
    }))
      .then((form) => ({
        ...UtilsService.dtoToModel(form),
        startsAt: UtilsService.unixToDate(form.startsAt),
      }));
  }

  submitFormResult(tournamentId: string,
    formId: string,
    betting: IFormBettings<any>,
    notify: boolean): Promise<void> {
    return firstValueFrom(this.httpClient.put<void>(`${API_PATH}tournaments/${tournamentId}/forms/${formId}/results`, {
      betting,
      notify,
    } as ICreateFormResultDto));
  }
}
